import { useEffect, useState } from 'react';

/** Re-renders the caller every `ms` (default 10 s) so relative times like "12s ago" stay accurate. */
export function useNow(ms = 10_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
